var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 10.434783,
    rx: 1,
    width: 14.608696,
    x: 1.391304,
    y: 0.695652
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0a17a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030e88"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1e36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d51931"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.391304.695652h14.608696v10.434783h-14.608696z",
    fill: "url(#c)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.47826087 2.94258606-3.02721997-2.59475997h1.39955564l2.43478261 1.73913043h.48443086l3.23018999-2.01886874v.80147744c0 .2104412-.1161144.43584943-.2906715.56053307l-2.14411111 1.53150794v.35667728l2.18241426 1.87064078c.32147625.27555108.14177981.72411919-.26937078.72411919-.17058356 0-.37893906-.06682851-.52109807-.16837066l-2.19906369-1.57075978h-.48443086l-3.23018999 2.01886875v-1.15438802l2.43478261-1.73913043z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.82608696 2.7826087-2.43478261-2.08695653h.34782608l2.43478261 1.73913044h.69565218l2.78260869-1.73913044v.17391305c0 .09604952-.06018597.21690302-.14501522.27749534l-2.28976739 1.63554814v.69565217l2.30387813 1.97475267c.07229655.06196848.05023193.11220385-.04300856.11220385-.09604952 0-.23409901-.04298998-.31892826-.1035823l-2.28976739-1.63554813h-.69565218l-2.78260869 1.73913043v-.34782609l2.43478261-1.73913043z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.39130435 2.43478261v1.39130435h2.43478261v1.7423381c0 .1903275.14889393.34461842.35108483.34461842h.68913468c.1938988 0 .35108483-.15008877.35108483-.34461842v-1.7423381h2.44140625c.18844091 0 .34120245-.14889394.34120245-.35108484v-.68913468c0-.1938988-.14960513-.35108483-.34120245-.35108483h-2.44140625v-1.73913044h-1.39130434v1.73913044z",
    fill: "url(#a)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.39130435 2.7826087h2.78260869v-.34782609-1.73913044h.69565218v1.73913044.34782609h2.78260869v.69565217h-2.78260869v.34782609 1.73913043h-.69565218v-1.73913043-.34782609h-2.78260869z",
    fill: "url(#d)",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4.52173913 9.2173913-.61334113.32245253.11713773-.68296543-.4962034-.48367875.68573623-.09964327.30667057-.62138247.30667057.62138247.68573623.09964327-.4962034.48367875.11713773.68296543z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.826087 9.73913043-.4919004.1440743.1440743-.49190038-.1440743-.49190038.4919004.14407429.4919003-.14407429-.1440743.49190038.1440743.49190038z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.826087 3.13043478-.4919004.14407428.1440743-.49190036-.1440743-.49190037.4919004.14407428.4919003-.14407428-.1440743.49190037.1440743.49190036z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.9130435 5.2173913-.4919004.14407429.1440743-.49190037-.1440743-.49190037.4919004.14407428.4919004-.14407428-.1440743.49190037.1440743.49190037z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.73913043 5.91304348-.49190038.14407428.1440743-.49190037-.1440743-.49190037.49190038.14407428.49190037-.14407428-.1440743.49190037.1440743.49190037z",
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.8695652 6.7826087-.2459502.07203714.0720372-.24595019-.0720372-.24595018.2459502.07203714.2459502-.07203714-.0720371.24595018.0720371.24595019z",
    mask: "url(#e)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAu);
export default __webpack_public_path__ + "static/media/AU.05d346d5264741bc52d650938dba4aef.svg";
export { ForwardRef as ReactComponent };